export default __webpack_public_path__ + "static/108001-4115cba66d64baf524c04921f5f72b24.jpg";